import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import SEO from '../components/seo/SEO';

const PageWrapper = styled.div`
  display: flex;
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.theme.colors.muted};
`;

const Content = styled.div`
  text-align: center;
`;

const Title = styled.h1`
  margin-bottom: 1rem;
  font-size: 2.25rem;
  font-weight: ${props => props.theme.typography.fontWeights.bold};
`;

const Text = styled.p`
  margin-bottom: 1rem;
  font-size: 1.25rem;
  color: ${props => props.theme.colors.mutedForeground};
`;

const Link = styled.a`
  color: ${props => props.theme.colors.primary};
  text-decoration: underline;
  
  &:hover {
    color: ${props => props.theme.colors.primary}dd;
  }
`;

const NotFound = () => {
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    console.error('404 Error: User attempted to access non-existent route:', location.pathname);
  }, [location.pathname]);

  return (
    <PageWrapper>
      <SEO
        title={t('error.404.title')}
        description={t('error.404.message')}
        noindex
      />
      <Content>
        <Title>404</Title>
        <Text>{t('error.404.message')}</Text>
        <Link href="/">{t('error.404.home')}</Link>
      </Content>
    </PageWrapper>
  );
};

export default NotFound;


